/**
 * PDP sticky section navigation bar
 * Active state and click handling. Relies on global scrollToBlock() from product section.
 */

(function() {
  const CLICK_LOCK_MS = 1200;
  const SCROLL_OFFSET_FALLBACK = 120;
  const SCROLL_OFFSET_HEADER_EXTRA = 80;
  const FOOTER_OVERLAP_EPSILON_PX = 1;
  const FOOTER_OVERLAP_UPDATE_THRESHOLD_PX = 2;
  const FOOTER_STOP_GAP_PX = 6;
  const REVIEWS_HIDE_CLASS = 'pdp-sticky-nav--is-hidden';

  function init() {
    const nav = document.querySelector('.pdp-sticky-nav');
    if (!nav) return;
    const footer = document.querySelector('#shopify-section-footer') || document.querySelector('footer');
    const reviewsSection = document.querySelector('.product__reviews');
    const reviewsTitle = reviewsSection ? reviewsSection.querySelector('.product__reviews-title') : null;
    const reviewsTrigger = reviewsTitle || reviewsSection;

    const navLinks = nav.querySelectorAll('.pdp-sticky-nav__link');
    const targetIds = [].map.call(navLinks, function(link) { return link.getAttribute('data-target'); }).filter(Boolean);

    const sectionElements = targetIds
      .map(function(id) { return document.getElementById(id); })
      .filter(Boolean);
    if (sectionElements.length === 0) return;

    function setActiveSection(sectionId) {
      navLinks.forEach(function(link) {
        const isActive = link.getAttribute('data-target') === sectionId;
        link.classList.toggle('is-active', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'location');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    function getCurrentSectionId() {
      const header = document.querySelector('s-header');
      const offset = header ? header.offsetHeight + SCROLL_OFFSET_HEADER_EXTRA : SCROLL_OFFSET_FALLBACK;
      const passed = sectionElements.filter(function(el) {
        return el.getBoundingClientRect().top <= offset;
      });
      if (passed.length === 0) return sectionElements[0].id;
      passed.sort(function(a, b) {
        return b.getBoundingClientRect().top - a.getBoundingClientRect().top;
      });
      return passed[0].id;
    }

    let lockedSectionId = null;
    let lockTimeout = null;
    let lastFooterOffset = -1;

    window.setPdpNavScrollTarget = function(sectionId) {
      lockedSectionId = sectionId;
      setActiveSection(sectionId);
      if (lockTimeout) clearTimeout(lockTimeout);
      lockTimeout = setTimeout(function() {
        lockedSectionId = null;
        lockTimeout = null;
        syncActiveFromScroll();
      }, CLICK_LOCK_MS);
    };

    function syncActiveFromScroll() {
      setActiveSection(lockedSectionId || getCurrentSectionId());
    }

    function updateNavFooterOffset() {
      if (!footer) return;
      const footerTop = footer.getBoundingClientRect().top;
      const overlap = Math.max(0, window.innerHeight - footerTop);
      const nextOffset = overlap > FOOTER_OVERLAP_EPSILON_PX
        ? Math.round(overlap + FOOTER_STOP_GAP_PX)
        : 0;
      if (Math.abs(nextOffset - lastFooterOffset) < FOOTER_OVERLAP_UPDATE_THRESHOLD_PX) return;
      nav.style.bottom = nextOffset + 'px';
      lastFooterOffset = nextOffset;
    }

    function updateNavVisibilityAtReviews() {
      if (!reviewsTrigger) return;
      const triggerTop = reviewsTrigger.getBoundingClientRect().top;
      const hasReviewsEnteredViewport = triggerTop <= window.innerHeight;
      nav.classList.toggle(REVIEWS_HIDE_CLASS, hasReviewsEnteredViewport);
    }

    let scrollRafId = null;
    window.addEventListener('scroll', function() {
      if (scrollRafId) window.cancelAnimationFrame(scrollRafId);
      scrollRafId = window.requestAnimationFrame(function() {
        scrollRafId = null;
        syncActiveFromScroll();
        updateNavFooterOffset();
        updateNavVisibilityAtReviews();
      });
    }, { passive: true });
    window.addEventListener('resize', function() {
      footerDocTop = null;
      updateNavFooterOffset();
      updateNavVisibilityAtReviews();
    }, { passive: true });

    if (typeof window.ResizeObserver === 'function') {
      const layoutObserver = new ResizeObserver(function() {
        updateNavFooterOffset();
        updateNavVisibilityAtReviews();
      });
      layoutObserver.observe(document.body);
      if (reviewsSection) layoutObserver.observe(reviewsSection);
    }

    const observer = new IntersectionObserver(syncActiveFromScroll, {
      root: null,
      rootMargin: '0px',
      threshold: [0, 0.1, 0.5, 1]
    });
    sectionElements.forEach(function(el) { observer.observe(el); });

    navLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        const sectionId = link.getAttribute('data-target');
        if (!sectionId) return;
        e.preventDefault();
        if (typeof window.scrollToBlock === 'function') window.scrollToBlock(sectionId, e);
        window.setPdpNavScrollTarget(sectionId);
        link.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });
    });

    syncActiveFromScroll();
    updateNavFooterOffset();
    updateNavVisibilityAtReviews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

